<div>
  <form-row-input
      [label]="label"
      [inputType]="isPlaintextInput ? 'text' : 'password'"
      [icon]="'far-lock'"
      [model]="passwordA"
      (modelChange)="passAModelChange($event)"
      [maxWidthPx]="maxWidthPx"
      [inputDisabled]="inputDisabled"
      [inputRequired]="inputRequired"
      [readonly]="inputReadonly"
      [maxlength]="maxlength"
      [showErrorBorder]="showErrorBorder || (passwordA?.length && !isPasswordValid)"
      [disallowTabNavToBtn]="disallowTabNavToBtn"
      (onKeyPress)="onInputKeyPress($event)"
      (onFocused)="onFocus($event)"
      (valueChangeNative)="onInputValueChange($event)"
      data-cy="new-password"
  ></form-row-input>
  <div class="w-100 pass-str-indicator-container">
    <div class="pass-str-indicator-bar" [ngClass]="{
    'weak': passwordStrength < 2,
    'medium': passwordStrength === 2,
    'strong': passwordStrength === 3,
    'veryStrong': passwordStrength === 4,
    'red': passwordStrength < 1 || !passwordA?.length || !hasPasswordUpperCaseChar || !hasPasswordLowerCaseChar || !hasPasswordNumericChar,
    'empty': !passwordA?.length,
  }"></div>
    <div class="pass-str-indicator-bar"
         [ngClass]="{
    'medium': passwordStrength === 2,
    'strong': passwordStrength === 3,
    'veryStrong': passwordStrength === 4,
    'red': passwordStrength < 1 || !passwordA?.length || !hasPasswordUpperCaseChar || !hasPasswordLowerCaseChar || !hasPasswordNumericChar,
    'empty': !passwordA?.length,

  }"></div>
    <div class="pass-str-indicator-bar"
         [ngClass]="{
    'strong': passwordStrength === 3,
    'veryStrong': passwordStrength === 4,
    'red': passwordStrength < 1 || !passwordA?.length || !hasPasswordUpperCaseChar || !hasPasswordLowerCaseChar || !hasPasswordNumericChar,
    'empty': !passwordA?.length,

  }"></div>
    <div class="pass-str-indicator-bar"
         [ngClass]="{
    'veryStrong': passwordStrength === 4,
    'red': passwordStrength < 1 || !passwordA?.length || !hasPasswordUpperCaseChar || !hasPasswordLowerCaseChar || !hasPasswordNumericChar,
    'empty': !passwordA?.length,

  }"></div>
  </div>
  <div class="pass-strength-string"
       *ngIf="passwordA?.length"
       [ngClass]="{
      'pass-red': passwordStrength < 2 || !passwordA?.length || !hasPasswordUpperCaseChar || !hasPasswordLowerCaseChar || !hasPasswordNumericChar || !isPasswordValid,
      'pass-medium': passwordStrength === 2,
      'pass-strong': passwordStrength > 2,
    }">
    {{ passwordStrengthString | translate }}
  </div>
  <div class="pass-wrap">
    <div [ngClass]="{ 'pass-empty': !passwordA?.length, 'pass-ok': passwordA?.length && passwordStrength > 0, 'pass-not-ok': passwordA?.length && passwordStrength < 1 }" class="mt-1">
      <i class="far fa-circle" *ngIf="!passwordA?.length"></i>
      <i class="fas fa-times-circle" *ngIf="passwordA?.length && passwordStrength < 1"></i>
      <i class="fas fa-check-circle" *ngIf="passwordA?.length && passwordStrength > 0"></i>
      <span>&nbsp;{{ 'passwordStrength.hasMinChars' | translate }}</span>
    </div>
    <div [ngClass]="{ 'pass-empty': !passwordA?.length, 'pass-ok': passwordA?.length && hasPasswordUpperCaseChar, 'pass-not-ok': passwordA?.length && !hasPasswordUpperCaseChar }" class="mt-1">
      <i class="far fa-circle" *ngIf="!passwordA?.length"></i>
      <i class="fas fa-times-circle" *ngIf="passwordA?.length && !hasPasswordUpperCaseChar"></i>
      <i class="fas fa-check-circle" *ngIf="passwordA?.length && hasPasswordUpperCaseChar"></i>
      <span>&nbsp;{{ 'passwordStrength.hasUpperCase' | translate }}</span>
    </div>
    <div [ngClass]="{ 'pass-empty': !passwordA?.length, 'pass-ok': passwordA?.length && hasPasswordLowerCaseChar, 'pass-not-ok': passwordA?.length && !hasPasswordLowerCaseChar }" class="mt-1">
      <i class="far fa-circle" *ngIf="!passwordA?.length"></i>
      <i class="fas fa-times-circle" *ngIf="passwordA?.length && !hasPasswordLowerCaseChar"></i>
      <i class="fas fa-check-circle" *ngIf="passwordA?.length && hasPasswordLowerCaseChar"></i>
      <span>&nbsp;{{ 'passwordStrength.hasLowerCase' | translate }}</span>
    </div>
    <div [ngClass]="{ 'pass-empty': !passwordA?.length, 'pass-ok': passwordA?.length && hasPasswordNumericChar, 'pass-not-ok': passwordA?.length && !hasPasswordNumericChar }" class="mt-1 mb-2">
      <i class="far fa-circle" *ngIf="!passwordA?.length"></i>
      <i class="fas fa-times-circle" *ngIf="passwordA?.length && !hasPasswordNumericChar"></i>
      <i class="fas fa-check-circle" *ngIf="passwordA?.length && hasPasswordNumericChar"></i>
      <span>&nbsp;{{ 'passwordStrength.hasNumber' | translate }}</span>
    </div>
  </div>
  <form-row-input
      *ngIf="!isSingleInput"
      [label]="'password.repeat'"
      [inputType]="isPlaintextInput ? 'text' : 'password'"
      [icon]="'far-lock'"
      [model]="passwordB"
      (modelChange)="passBModelChange($event)"
      [maxWidthPx]="maxWidthPx"
      [inputDisabled]="inputDisabled"
      [inputRequired]="inputRequired"
      [readonly]="inputReadonly"
      [maxlength]="maxlength"
      [showErrorBorder]="showErrorBorder || (passwordB?.length && !doesAAndBMatch)"
      [disallowTabNavToBtn]="disallowTabNavToBtn"
      (onKeyPress)="onInputKeyPress($event)"
      (onFocused)="onFocus($event)"
      (valueChangeNative)="onInputValueChange($event)"
      data-cy="repeat-password"
  ></form-row-input>
</div>
